import { render, staticRenderFns } from "./managmentLanguage.vue?vue&type=template&id=321ccc49&scoped=true"
import script from "./managmentLanguage.vue?vue&type=script&lang=js"
export * from "./managmentLanguage.vue?vue&type=script&lang=js"
import style0 from "./managmentLanguage.vue?vue&type=style&index=0&id=321ccc49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321ccc49",
  null
  
)

export default component.exports